import { useEffect, useState } from "react";

// Msal imports
import { MsalAuthenticationTemplate, useMsal, useAccount } from "@azure/msal-react";
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from '../../authConfig';

import { ErrorComponent } from '../../Layout/ErrorComponent';
import LoadingIndicator from '../../Layout/LoadingIndicator';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import Landing from '../Landing';

// Msal provides logged user's data to the app. 
// We are passing customer information downstream in the authProps object. 
const ProtectedContent = () => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [atsResponse, setAtsResponse] = useState(null);
    const authProps = {instance:instance, account:account, inProgress:inProgress};

    useEffect(() => {
        if (!atsResponse && account && inProgress === InteractionStatus.None) {
            instance.acquireTokenSilent({
                ...loginRequest,
                account: account
            }).then((response) => {
                setAtsResponse(response);
            });
        }
    }, [account, inProgress, instance, atsResponse]);

    return (
        <>
            <Header />
            <Landing 
                authProps={authProps}
            />     
            <Footer />        
       </>
    );
};

// MsalAuthenticationTemplate will redirect anon user to the login screen.
// If the user is logged in it will present the CDP.
const Protected = (props) => {
    const authRequest = {
        ...loginRequest
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={ErrorComponent}
            loadingComponent={LoadingIndicator}
        >
            <ProtectedContent />
        </MsalAuthenticationTemplate>
    )
}

export default Protected;